<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Logo Crime</b-card-title>
      </b-card-header>
      <b-card-body class="pb-1">
        <b-card-text>
          <p>It’s important that the appearance of the logo remains consistent. The logo should not be misinterpreted, modified, or added to.<br>Some logo crimes are listed below:</p>
        </b-card-text>
        <b-table-simple
          caption
          responsive
          class="logo-crime country-logo-table"
        >
          <b-tbody>
            <b-tr>
              <b-td>
                Do not crop the logo
              </b-td>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/horizontal-logo-pink.svg')"
                  alt="EasyParcel Logo"
                  style="width: 80px; height: 80px; object-fit: cover;"
                  class="border-secondary border-lighten-5 border-2 rounded"
                />
              </b-td>
              <b-td>
                Do not disproportionately scale the logo.
              </b-td>
              <b-td>
                <b-img
                  fluid
                  :src="require('@/assets/images/logo/logo-crime/ep-logo-distort.png')"
                  alt="EasyParcel Logo"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                Do not change the transparency of the logo
              </b-td>
              <b-td>
                <b-img
                  fluid
                  :src="require('@/assets/images/logo/horizontal-logo-pink.svg')"
                  alt="EasyParcel Logo"
                  style="opacity: 0.5;"
                />
              </b-td>
              <b-td>
                Do not use drop shadow or any other effects
              </b-td>
              <b-td>
                <b-img
                  fluid
                  :src="require('@/assets/images/logo/logo-crime/ep-logo-drop-shadow.png')"
                  alt="EasyParcel Logo"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                Do not change the color of the logo
              </b-td>
              <b-td>
                <b-img
                  fluid
                  :src="require('@/assets/images/logo/logo-crime/ep-logo-color.png')"
                  alt="EasyParcel Logo"
                />
              </b-td>
              <b-td>
                Do not outline the logo
              </b-td>
              <b-td>
                <b-img
                  fluid
                  :src="require('@/assets/images/logo/logo-crime/ep-logo-outline.png')"
                  alt="EasyParcel Logo"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                Do not use unapproved color combinations.
              </b-td>
              <b-td>
                <b-img
                  fluid
                  :src="require('@/assets/images/logo/horizontal-logo-pink.svg')"
                  alt="EasyParcel Logo"
                  class="bg-warning rounded"
                />
              </b-td>
              <b-td>
                Do not use the logo on top of complex backgrounds.
              </b-td>
              <b-td>
                <b-img
                  fluid
                  :src="require('@/assets/images/logo/logo-crime/ep-logo-complex-bg.jpg')"
                  alt="EasyParcel Logo"
                  class="rounded"
                />
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BTableSimple, BTr, BTbody, BTd, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BTableSimple,
    BTr,
    BTbody,
    BTd,
    BImg,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')
    return { skin, isDark }
  },
}
</script>

<style>
  .logo-crime .img-fluid {max-width: 220px;}
</style>
